(() => {
  const presaleEnd = Date.parse('2026-09-06T23:59:59+02:00');

  const synchronizePresaleState = () => {
    const isActive = Date.now() <= presaleEnd;
    document.documentElement.dataset.adventPresaleState = isActive ? 'active' : 'ended';

    document.querySelectorAll('[data-advent-presale-only]').forEach((element) => {
      element.hidden = !isActive;
      element.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    const craftedPointsLabel = document.body?.dataset.adventCraftedPointsLabel;
    if (craftedPointsLabel) {
      document.querySelectorAll('.alunir-crafted__points').forEach((element) => {
        element.setAttribute('aria-label', craftedPointsLabel);
      });
    }
  };

  synchronizePresaleState();
  document.addEventListener('shopify:section:load', synchronizePresaleState);
})();
